export interface UserDto {
  id: string
  email: string
}

const STORAGE_KEY = 'currentUser'

const isValid = (u: UserDto | null): u is UserDto => !!u?.id && !!u?.email

class UserService {
  saveUser(user: UserDto): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
  }

  getCurrentUser(): UserDto | null {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    try {
      const parsed = JSON.parse(raw) as UserDto
      return isValid(parsed) ? parsed : null
    } catch {
      return null
    }
  }

  clearUser(): void {
    localStorage.removeItem(STORAGE_KEY)
  }
}

export const userService = new UserService()
